import {
  ADD_CUSTOM_NAVIGATION_ITEMS,
  ADD_CUSTOM_NAVIGATION_ITEM,
  DELETE_CUSTOM_NAVIGATION_ITEM,
  UPDATE_CUSTOM_NAVIGATION_ITEM,
  FETCHING_CUSTOM_NAVIGATION_ITEMS,
  FETCHED_CUSTOM_NAVIGATION_ITEMS,
  ADD_PROJECTS,
  CLEAR_ALL
} from "../actions/constants";
import defaults from "./defaults";

const navigationReducer = (state = defaults.navigation, { type, payload }) => {
  switch (type) {
    case ADD_CUSTOM_NAVIGATION_ITEMS:
      const all = payload.list.filter((l) => !l.project_id)
      const proj = payload.list.filter((l) => l.project_id);
      const static_p = payload.list.filter((l) => l.static && l.location === "project");
      let list = { ...state.list, all };
      if (payload.project_id) {
        let all = [...proj, ...static_p];
        list[payload.project_id] = all;
      }
      return { ...state, list };
    case ADD_CUSTOM_NAVIGATION_ITEM:
      const existing_navigation_add = (state.list[payload.project_id || "all"] || []).filter((p) => p.id !== payload.id);
      return { ...state, list: { ...state.list, [payload.project_id || "all"]: [...existing_navigation_add, payload] } };
    case UPDATE_CUSTOM_NAVIGATION_ITEM:
      const updating_target_list = state.list[payload.project_id || "all"];
      const updating_target = updating_target_list.find((d) => d.id === payload.id);
      const updating_filtered = updating_target_list.filter((d) => d.id !== payload.id);
      const updating_with_updates = { ...updating_target, ...payload };
      return { ...state, updating_profile: false, list: { ...state.list, [payload.project_id || "all"]: [...updating_filtered, updating_with_updates] } };
    case DELETE_CUSTOM_NAVIGATION_ITEM:
      const current = state.list[payload.project_id || "all"];
      const remaining = current.filter((d) => d.id !== payload.id);
      return { ...state, list: { ...state.list, [payload.project_id || "all"]: remaining } };
    case FETCHING_CUSTOM_NAVIGATION_ITEMS:
      return { ...state, fetching: payload };
    case FETCHED_CUSTOM_NAVIGATION_ITEMS:
      return { ...state, fetched: { ...state.fetched, [payload.project_id || "all"]: new Date() } };
    case ADD_PROJECTS:
      return { ...state, fetched: {}, fetching: false, list: {} };
    case CLEAR_ALL:
      return defaults.navigation;
    default:
      return state;
  }
};

export default navigationReducer;